import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/minna/OFSP_Bread_Process_9.jpg";
import sandDredgingImage from "../../assets/minna/OFSP_Bread_Process_5.jpg";
import missionImage from "../../assets/Iwomen.png";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/minna/OFSP_Bread_Process_5.jpg";
import chysonImg from "../../assets/minna/OFSP_Bread_Process_9.jpg";
import farmImg from "../../assets/minna/OFSP_Bread_Process_4.jpg";
import consultancyImg from "../../assets/minna/minna2.jpeg";
import consultancy2Img from "../../assets/minna/minna4.jpeg";
import consultancy3Img from "../../assets/minna/minna3.jpeg";
import consultancy4Img from "../../assets/minna/OFSPBread2.jpg";
import consultancy5Img from "../../assets/minna/OFSP_Bread_8.jpg";
import consultancy6Img from "../../assets/minna/OFSP_Bread_Process_10.jpg";
import consultancy7Img from "../../assets/minna/OFSP_Bread_Process_7.jpg";
import consultancy8Img from "../../assets/minna/OFSP_Bread_Process_8.jpg";
import consultancy25Img from "../../assets/minna/minna.jpeg";
import consultancy9Img from "../../assets/minna/1.jpg";
import consultancy10Img from "../../assets/minna/2.jpg";
import consultancy11Img from "../../assets/minna/3.jpg";
import consultancy12Img from "../../assets/minna/1.mp4";
import consultancy13Img from "../../assets/minna/2.mp4";
import consultancy14Img from "../../assets/minna/3.mp4";
import consultancy15Img from "../../assets/minna/4.mp4";
//import bgIMG2 from "../../assets/bgIMG2.jpg";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const MinnaTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: consultancy7Img, caption: "Hands-On Workshop" },
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: consultancy5Img, caption: "Innovative Solutions" },
    { img: consultancy6Img, caption: "Agricultural Training" },
    { img: consultancy8Img, caption: "Empowering Youth" },
    { img: chysonImg, caption: "Chyson Foods" },
    { img: consultancy8Img, caption: "Minna Bread Training" },
    { img: consultancy25Img, caption: "minna" }
    , { img: consultancy9Img, caption: "OFSP Bread Production" }
    , { img: consultancy10Img, caption: "OFSP Bread Production" }
    , { img: consultancy11Img, caption: "OFSP Bread Production" }
    , { img: consultancy12Img, caption: "OFSP Bread Production" }
    , { img: consultancy13Img, caption: "OFSP Bread Production" }
    , { img: consultancy14Img, caption: "OFSP Bread Production" }
    , { img: consultancy15Img, caption: "OFSP Bread Production" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
             Hands-On Baking Techniques
            </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
Participants practice step-by-step OFSP bread production, from dough mixing to baking, ensuring skill transfer that can be applied immediately.
</p>
      <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The Minna Bread Training involved 8 bakeries from Minna and Bida. The training caused a lot of revolution as residents of these towns and surrounding communities started preferring OFSP Bread.
        </p>
        </div>
        <div className="md:w-1/2">
          <img src={chysonImg} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    rural: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Recipe Diversification
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The training introduced participants to various OFSP-based recipes, including bread, pastries, and snacks. This diversification enhances the nutritional value of baked goods while appealing to local tastes.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={trainingImg} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Food Safety & Quality Control
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Participants learned essential food safety practices, including hygiene standards, quality control measures, and proper storage techniques. This knowledge ensures that the OFSP bread products meet health regulations and maintain high quality.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy25Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    knowledge: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            Nutrition Advocacy: Chyson Foods
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Chyson Foods, a key partner in the training, advocates for the nutritional benefits of OFSP. They emphasize how incorporating OFSP into bread production can combat malnutrition and promote healthier diets in local communities.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="OFSP Bread Production & Chyson Foods" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Hands-On Baking Techniques
           </button>

          <button
            onClick={() => setActiveTab("rural")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "rural" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Recipe Diversification
                 </button>
               
          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Food Safety & Quality Control          </button>
          <button
            onClick={() => setActiveTab("knowledge")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "knowledge" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Nutrition Advocacy
          </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="OFSP BREAD PRODUCTION & CHYSON FOODS " />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
In a bid to increase the consumption of high nutrients Orange Fleshed Sweet Potato, Simdozi International Limited is interested in making potato puree into bread. This Orange Fleshed Sweet Potato Bread is gradually gaining wide acceptance.               </p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
In November 2024, some bakeries in Niger State invited us to conduct training for their Master Bakers on how to integrate OFSP into bread making. 
              </p>
            </div>
          </div>
        </div>
      </div>
 {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="Minna Bread Training Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
  <SwiperSlide key={index}>
    <div
      className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
      onClick={() => setModal({ img, caption })}
    >
      {img.endsWith(".mp4") ? (
        <video
          src={img}
          controls
          loop
          muted
          playsInline
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      ) : (
        <img
          src={img}
          alt={caption}
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      )}

      <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
        <p className="text-white text-lg font-bold">{caption}</p>
      </div>
    </div>
  </SwiperSlide>
))}

        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default MinnaTraining;
